import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import useAccessLevel from '../Pages/Organizations/hooks/useAccessLevel'
import errorToast from '../Components/Toasts/ErrorToast'
export default function OrganizationRoute({ children }) {
  const { id } = useParams()
  const navigate = useNavigate()

  const { isInternalAdmin, hasOrgAdminAccess } = useAccessLevel({
    o_f_id: id,
  })

  const hasAccess = isInternalAdmin || hasOrgAdminAccess

  useEffect(() => {
    if (!hasAccess) {
      errorToast(`You do not have access to this page.`)
      navigate('/artists')
    }
  }, [hasAccess])

  if (hasAccess) {
    return children
  }

  return null
}

OrganizationRoute.propTypes = {
  children: PropTypes.node,
}
